import React, { useContext, useEffect, useState } from 'react'
import { Navigate, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { UserContext } from '../../App';
import { BookOverview } from '../../components/dashboard/soldBook/bookOverview';
import { InsertTracking } from '../../components/dashboard/insertTracking';
import { BuyerDetails } from '../../components/dashboard/soldBook/buyerDetails';
import { Label } from '../../components/dashboard/soldBook/label';
import { Alert, BookSold, ConfirmOrRefund, SuccesBuy } from '../../components/dashboard/alert';
import { PaymentDetails } from '../../components/dashboard/soldBook/payment';
import { LoadingFull } from '../../components/loading';
import Details from '../../components/dashboard/shipments/sold/details';
import Products from '../../components/dashboard/shipments/products';
import Status from '../../components/dashboard/shipments/status';
import Payment from '../../components/dashboard/shipments/sold/payment';
import Chat from '../../components/dashboard/shipments/chat';

const Order = () => {

  const { dbId } = useParams();
  const [data, setData] = useState();
  const [ownsBook, setOwnsBook] = useState();
  const [errorMessage, setErrorMessage] = useState('')
  const [successMessage, setSuccessMessage] = useState('')
  const navigate = useNavigate()
  const { auth, user, socket, notifications, setNotifications } = useContext(UserContext)
  const token = localStorage.getItem('token')
  const [searchParams, setSearchParams] = useSearchParams();
  const [reloadData, setReloadData] = useState(false);
  const [messages, setMessages] = useState();
  
  useEffect(() => {
    axios({
      method: 'post',
      url: '/api/findShipment',
      data: {
        'shipment': searchParams.get('id')
      },
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    .then(response => {
      setData(response.data);
      setMessages(response.data.messages)
    })
    .catch(error => {
      navigate('/')
    });
  }, []);

  useEffect(() => {
    if (typeof data !== 'undefined') {
      socket.on('new_message', (chat) => {
        if (chat.chatId === data._id) {
          setMessages(prev => {
            if (chat.messages[chat.messages.length-1].sender !== user._id && chat.messages[chat.messages.length-1].seen === false) {
              chat.messages[chat.messages.length-1].seen = true
              socket.emit('message_seen', chat.chatId)
            }
            return chat.messages
          })
        }
      });
      
      if (data.messages.length > 0 && data.messages[data.messages.length-1].sender !== user._id && data.messages[data.messages.length-1].seen === false) {
        setMessages(prev => {
          const newList = [...prev]
          newList[newList.length-1].seen = true
          socket.emit('message_seen', data._id)
          return newList
        })
      }
    }
    
    return () => {
      socket.off('new_message'); // Fjern lytteren, når komponenten afmonteres
    };
  }, [data])

  useEffect(() => {
    if (typeof data !== 'undefined' && notifications.some(a => a.chatId === data._id)) {
      setNotifications(prev => {
        return prev.filter(a => a.chatId !== data._id)
      })
    }
  }, [notifications, data])

  if (!auth) {
    return <Navigate to="/login" />
  }

  return (
    (typeof data === 'undefined') ?
      <LoadingFull />
    :
      <div className="w-full">
        <div className="h-full flex flex-col gap-y-5 justify-between">
          {(data.buyer._id === user._id) ?
            ((data.status === 0 && data.deliveryType === 3) || data.status === 2) ?
              <ConfirmOrRefund data={data} setReloadData={setReloadData} reloadData={reloadData} />
            : (searchParams.get("success") === "true") ?
              <SuccesBuy data={data} />
            :
              ""
          :
            (data.status === 0) ?
              <BookSold data={data} />
            :
              ""}
          {(data.seller._id === user._id) ?
            <Products seller={data.seller} deliveryType={data.deliveryType} products={data.products} />
          :
            ""}
          <div className="flex gap-5 flex-col lg:flex-row h-auto">
            {data.seller._id === user._id ?
              data.deliveryType !== 3 ?
                data.status === 0 ?
                  <Details data={data} />
                :
                  <Status data={data} />
              :
                <Status data={data} />
            :
              <Status data={data} />}
            {(data.seller._id === user._id) ?
              <Payment data={data} />
            :
              <Products seller={data.seller} deliveryType={data.deliveryType} products={data.products} />
            }
          </div>
          <Chat data={data} messages={messages} setMessages={setMessages} />
        </div>
      </div>
  )
}


export default Order;